import { useEffect, useState } from "react";
import { Line, Pie } from "react-chartjs-2";
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import Navbar from "../Navbar";
import RecipeTable from "./RecipeTable";
import Footer from "../Footer";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const Url = process.env.REACT_APP_BASE_URL;

const ItemData = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalrevenue, setTotalRevenue] = useState("");
  const [totalcount, setTotalCount] = useState("");
  const [groupranking, setGroupRanking] = useState("");

  const token = localStorage.getItem("token");
  const outlet = localStorage.getItem("selectedOutlet");
  const description = localStorage.getItem("group");
  const name = localStorage.getItem("item");

  const fetchData = async () => {
    const payload = {
      token: token,
      outlet: outlet,
      description: description,
      name: name,
    };

    try {
      const response = await axios.post(`${Url}/give_itemdetails`, payload);
      setData(response.data);
      setLoading(false);
      setTotalCount(response.data.Total_Count);
      setTotalRevenue(response.data.Total_Revenue);
      setGroupRanking(response.data.Group_Ranking);
    } catch (err) {
      setError("Error fetching data");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  const lastMonthData = {
    labels: data.Last_Monthly.map(
      (item) => `${item.start_date} to ${item.end_date} (${item.week})`
    ),
    datasets: [
      {
        label: "Total Count",
        data: data.Last_Monthly.map((item) => item.total_count),
        fill: false,
        borderColor: "rgba(75,192,192,1)",
        tension: 0.1,
      },
    ],
  };

  const yearlySalesData = {
    labels: data.Yearly_sales_json.map((item) => item.monthName),
    datasets: [
      {
        label: "Total Count",
        data: data.Yearly_sales_json.map((item) => parseFloat(item.TotalCount)),
        fill: false,
        borderColor: "rgba(153,102,255,1)",
        tension: 0.1,
      },
    ],
  };

  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const itemRanksData = {
    labels: data.Group_AllItem_Ranks.map((item) => item.ItemName),
    datasets: [
      {
        label: "Item Count",
        data: data.Group_AllItem_Ranks.map((item) => item.Count),
        backgroundColor: data.Group_AllItem_Ranks.map(() => getRandomColor()),
        borderColor: data.Group_AllItem_Ranks.map(() => getRandomColor()),
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: true,
      },
      legend: {
        position: "top",
      },
    },
  };

  return (
    <>
      <Navbar />

      <div className="mb-5">
        <div className="text-center my-3">
          <div className="mb-1">
            <div className="text-2xl font-semibold text-gray-900">
              {name}
            </div>
            <div className="text-base text-gray-900 font-semibold italic">
              Group Name: {description}
            </div>
          </div>

          <div className="font-semibold flex justify-center gap-10 text-gray-700">
            <div>Total Revenue: {totalrevenue}</div>
            <div>Total Count: {totalcount}</div>
            <div>Group Ranking: {groupranking}</div>
          </div>
        </div>


        {/*For Alice*/}
        <RecipeTable
          baseUrl={Url}
          token={token}
          itemName={name}
          outlet={outlet}
        />

        <div className="max-w-5xl mx-auto">
          <h4 className="mt-5 text-center">Weekly Count</h4>
          <div className="max-w-full h-[300px]">
            <Line data={lastMonthData} options={chartOptions} />
          </div>

          <h4 className="mt-8 text-center">Yearly Count</h4>
          <div className="max-w-full h-[300px] mb-8">
            <Line data={yearlySalesData} options={chartOptions} />
          </div>

          <div className="flex flex-col lg:flex-row justify-center gap-8">
            <div className="w-full lg:w-3/4">
              <h4 className="mt-6 text-center text-lg font-semibold">
                Item Count
              </h4>

              <div className="h-[450px] w-full">
                <Pie data={itemRanksData} options={chartOptions} />
              </div>
            </div>

            {/* Table */}
            <div className="w-full lg:w-[400px]">
              <div className="mt-5 overflow-hidden rounded-sm border border-gray-200 shadow-sm">
                <div className="max-h-[450px] overflow-auto tiny-scrollbar">
                  <table className="w-full border-collapse text-sm">
                    <thead className="sticky top-0 bg-gray-100 z-10">
                      <tr>
                        <th className="border-b px-4 py-2.5 text-left font-semibold text-gray-700">
                          Item Name
                        </th>
                        <th className="border-b px-4 py-2.5 text-center font-semibold text-gray-700">
                          Count
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {data.Group_AllItem_Ranks?.length > 0 ? (
                        data.Group_AllItem_Ranks.map((item, index) => (
                          <tr
                            key={index}
                            className="hover:bg-gray-50"
                          >
                            <td className="border-b px-4 py-2">
                              {item.ItemName}
                            </td>
                            <td className="border-b px-4 py-2 text-center">
                              {item.Count}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={2}
                            className="px-4 py-8 text-center text-gray-500"
                          >
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ItemData;